export default "__VITE_ASSET__550de12b__"